import { createApiRequestType, strictObjectAccess } from '@ackee/redux-utils';

import { EntityKey } from 'constants/index';

const apiRequest = createApiRequestType({ modulePrefix: EntityKey.DOCUMENT_INVOICES });

export const fetchInvoicesTypes = strictObjectAccess({ ...apiRequest({ typePrefix: 'FETCH_INVOICES_' }) });
